import { H2RButton, H2RInput, H2RSelect } from "../../imports";
import OpenExternal from "../helpers/OpenExternal";
import { msToStringFormatted, stringToMS } from "../helpers/time";
import TimeCountdown from "../output/TimeCountdown";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RInput
				label="Display format (Large text)"
				value={cue.format}
				placeholder="HH:mm:ss"
				onChange={(value) => {
					onUpdate({ format: value });
				}}
			/>
			<OpenExternal
				buttonText={"More formatting options"}
				isElectronLink={`https://docs.h2r.graphics/graphics/time#display-format`}
				isNotElectronLink={`https://docs.h2r.graphics/graphics/time#display-format`}
			/>
			<H2RInput
				label="Duration (HH:MM:SS)"
				value={msToStringFormatted(cue.duration, false)}
				placeholder="e.g. 00:01:00 = 1 minute"
				onChange={(value) => {
					onUpdate({ duration: stringToMS(value) });
				}}
			/>

			<div className="flex gap-2 items-end">
				<H2RInput
					label="Message to speaker"
					placeholder="Start wrapping up!"
					value={cue.speakerMessage}
					onChange={(value) => {
						onUpdate({ speakerMessage: value });
					}}
				/>
				<H2RButton
					text={cue.showSpeakerMessage ? "Hide" : "Show"}
					colour={cue.showSpeakerMessage ? "main" : "dark"}
					size="small"
					css="h-6"
					onClick={() => {
						const bool = cue.showSpeakerMessage ? false : true;
						onUpdate({ showSpeakerMessage: bool });
					}}
				/>
			</div>

			<H2RSelect
				label="On end"
				selected={cue.onEnd || "negative"}
				onChange={(value) => {
					onUpdate({ onEnd: value });
				}}
				options={[
					{
						label: "Show negative numbers",
						value: "negative",
					},
					{
						label: "Hold on 00:00:00",
						value: "hold",
					},
					{
						label: "Reset timer",
						value: "reset",
					},
					{
						label: "Show message",
						value: "message",
					},
				]}
			/>

			{cue.onEnd === "message" && (
				<H2RInput
					label="End message"
					placeholder="You're done!"
					value={cue.endMessage}
					onChange={(value) => {
						onUpdate({ endMessage: value });
					}}
				/>
			)}

			<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>

			<span className=" text-gray-500 tracking-wide font-semibold text-xs">
				Tracking bar
			</span>
			<div className="flex space-x-2">
				<H2RSelect
				label="Direction"
				selected={cue.trackingDirection || 'right'}
				onChange={(value) => {
					onUpdate({ trackingDirection: value });
				}}
				options={[
					{
						label: "To right",
						value: "right",
					},
					{
						label: "To left",
						value: "left",
					},
				]}
			/>
			<H2RInput
					label={`Colour`}
					value={cue.barColour || "white"}
					colourPicker={true}
					onChange={(value) => {
						onUpdate({ barColour: value });
					}}
				/>
			</div>

			<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>

			<span className=" text-gray-500 tracking-wide font-semibold text-xs">
				Warning one
			</span>
			<div className="flex space-x-2">
				<H2RInput
					label="HH:MM:SS"
					value={msToStringFormatted(cue.warnOneTime, false)}
					placeholder="00:03:00"
					onChange={(value) => {
						onUpdate({ warnOneTime: stringToMS(value) });
					}}
				/>
				<H2RInput
					label={`Colour`}
					value={cue.warnOneColour || "orange"}
					colourPicker={true}
					onChange={(value) => {
						onUpdate({ warnOneColour: value });
					}}
				/>
			</div>

			<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>

			<span className=" text-gray-500 tracking-wide font-semibold text-xs">
				Warning two
			</span>
			<div className="flex space-x-2">
				<H2RInput
					label="HH:MM:SS"
					value={msToStringFormatted(cue.warnTwoTime, false)}
					placeholder="00:01:00"
					onChange={(value) => {
						onUpdate({ warnTwoTime: stringToMS(value) });
					}}
				/>
				<H2RInput
					label={`Colour`}
					value={cue.warnTwoColour || "red"}
					colourPicker={true}
					onChange={(value) => {
						onUpdate({ warnTwoColour: value });
					}}
				/>
			</div>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span
				style={{ fontVariantNumeric: "tabular-nums" }}
				className="font-semibold inline-block"
			>
				<TimeCountdown cue={cue} cuePreview={true} />
			</span>
		</div>
	);
};
